import { AsideMenuItem } from './aside-menu-item';
import { Loading } from 'components/loading';
import { useAuth } from 'features/auth/contexts/auth';
import { Page } from 'features/shared/model';

export function AsideMenuKnowledge() {
  const { isGranted, currentPermissions } = useAuth();

  const canReadDocumentsLogs = isGranted(Page.DocumentsLog, 'read');
  const canReadMaintenanceTasks = isGranted(Page.MaintenanceTasks, 'read');
  const canReadPrinterOverView = isGranted(Page.PrintersOverview, 'read');
  // const canReadRiskAssessment = isGranted(Page.RiskAssessment, 'read');
  const canReadRiskAssessment = true;

  return currentPermissions ? (
    <>
      <div className="text-gray-400 mb-7 fs-7 text-uppercase">GENERAL</div>

      {canReadDocumentsLogs && (
        <AsideMenuItem to="/documents-log" icon="/media/icons/custom/document.svg" title="Policies & Procedures" />
      )}

      {canReadMaintenanceTasks && (
        <AsideMenuItem
          to="/maintenance-tasks/list"
          icon="/media/icons/custom/attendence.svg"
          title="Maintenance Tasks"
        />
      )}

      {canReadPrinterOverView && (
        <AsideMenuItem to="/printer-overview/list" icon="/media/icons/custom/printer.svg" title="Printer Overview" />
      )}

      {canReadRiskAssessment && (
        <AsideMenuItem
          to="/risk-assessment"
          icon="/media/icons/duotune/general/patch-exclamation.svg"
          title="Risk Assessment"
        />
      )}

      <AsideMenuItem
        to="/vehicle-accident-log"
        icon="/media/icons/duotune/abstract/abs017.svg"
        title="Vehicle Accident Log"
      />
    </>
  ) : (
    <Loading />
  );
}
